export const getForwardMedia = (media: any) => {
  if (media?.photo_FLAGPHOTO) {
    return {
      fwd_hash_img: media?.photo_FLAGPHOTO?.access_hash,
      fwd_type: media?.photo_FLAGPHOTO?.predicate_name,
    };
  }

  return {
    fwd_hash_img: media?.document?.access_hash,
    fwd_type: media?.document?.mime_type,
  };
};
